export type EvaSpaceSceneId = "base" | "rain" | "movie" | "memory" | "parcel";

export interface EvaSpaceScene {
  id: EvaSpaceSceneId;
  label: string;
  eyebrow: string;
  title: string;
  description: string;
  backgroundSrc: string;
}

export interface EvaSpaceMemory {
  id: string;
  title: string;
  description: string;
  metric: string;
  imageSrc: string;
}

const ROOT = "assets/eva-space";

export const EVA_SPACE_SCENES: EvaSpaceScene[] = [
  {
    id: "base",
    label: "共享空间",
    eyebrow: "共享空间",
    title: "车里的每件东西，都能被自然理解",
    description: "熟悉的空间语义，对应真实座舱能力。",
    backgroundSrc: `${ROOT}/scenes/01-space-base.webp`
  },
  {
    id: "rain",
    label: "雨夜同步",
    eyebrow: "共享状态",
    title: "车外在下雨，空间也进入雨夜",
    description: "天气、光线与真实车辆始终处于同一个状态。",
    backgroundSrc: `${ROOT}/scenes/02-space-rain-night.webp`
  },
  {
    id: "movie",
    label: "陪看电影",
    eyebrow: "共享状态",
    title: "坐下来，继续上次没看完的电影",
    description: "EVA 与座椅、灯光和内容一起进入陪伴状态。",
    backgroundSrc: `${ROOT}/scenes/03-space-movie-active.webp`
  },
  {
    id: "memory",
    label: "记忆房间",
    eyebrow: "共享经历",
    title: "这个空间，记得我们一起发生过什么",
    description: "点击照片墙，打开共同经历相册。",
    backgroundSrc: `${ROOT}/scenes/04-space-memory.webp`
  },
  {
    id: "parcel",
    label: "空间事件",
    eyebrow: "空间事件",
    title: "有快递待取",
    description: "包裹出现在空间里，EVA 会提醒你顺路处理。",
    backgroundSrc: `${ROOT}/scenes/05-space-parcel-event.webp`
  }
];

export const EVA_SPACE_MEMORIES: EvaSpaceMemory[] = [
  {
    id: "first-seaside",
    title: "第一次去海边",
    description: "海风吹进车窗，也吹开了第一段共同记忆。",
    metric: "首次抵达",
    imageSrc: `${ROOT}/memories/01-first-seaside.webp`
  },
  {
    id: "longest-day",
    title: "最长的一天",
    description: "从清晨到深夜，沿途的光被收进同一天。",
    metric: "860 km*",
    imageSrc: `${ROOT}/memories/02-longest-day.webp`
  },
  {
    id: "rainy-return",
    title: "雨夜归途",
    description: "雨声留在窗外，车里只剩熟悉的暖光。",
    metric: "共同歌单",
    imageSrc: `${ROOT}/memories/03-rainy-return.webp`
  },
  {
    id: "wait-for-dawn",
    title: "一起等天亮",
    description: "天亮之前抵达山顶，EVA 记住了第一束光。",
    metric: "日出 05:42*",
    imageSrc: `${ROOT}/memories/04-wait-for-dawn.webp`
  }
];

export const EVA_SPACE_CONCEPT_NOTE = "概念演示数据，正式版本读取真实行程记录";

export function getEvaSpaceScene(sceneId: EvaSpaceSceneId) {
  return EVA_SPACE_SCENES.find((scene) => scene.id === sceneId) ?? EVA_SPACE_SCENES[0];
}
